import { useEffect } from 'react';
import PropTypes from 'prop-types';

const Network = ({ setNetworkStatus }) => {
    useEffect(() => {
        window.addEventListener('offline', setNetworkStatus);
        window.addEventListener('online', setNetworkStatus);

        return () => {
            window.removeEventListener('offline', setNetworkStatus);
            window.removeEventListener('online', setNetworkStatus);
        }
    });

    return null;
}

Network.propTypes = {
    setNetworkStatus: PropTypes.func
};

export default Network;
